// New: UI_REVAMP

import { create } from 'zustand';

export const useBetTwo2DStore = create((set) => ({
	slots: [],
	hotNumbers: [],
	soldOutNumbers: [],
	updateSlot: (index, value) =>
		set((state) => {
			const newSlots = [...state.slots];
			newSlots[index] = value;
			return { slots: newSlots };
		}),
	setNumberLimit: (data) =>
		set({
			hotNumbers: data?.hotNumber || [],
			soldOutNumbers: data?.soldOut || [],
		}),
	clearSlots: () => set({ slots: [] }),
}));
